import { Navigate } from 'react-router-dom';

import { paths } from 'src/routes/paths';

import { useFeatureFlag } from '../feature-flags';
import type { FeatureFlagKey } from '../feature-flags';

// ----------------------------------------------------------------------

type Props = {
  flag: FeatureFlagKey;
  children: React.ReactNode;
};

/**
 * Redirects to the company dashboard if the feature flag is disabled.
 * Use this to wrap entire routes.
 *
 * ```tsx
 * <FeatureFlagGuard flag="report-builder">
 *   <ReportBuilderPage />
 * </FeatureFlagGuard>
 * ```
 */
export default function FeatureFlagGuard({ flag, children }: Props) {
  const enabled = useFeatureFlag(flag);

  if (!enabled) {
    return <Navigate to={paths.dashboard.company_managment_dashboard.index} replace />;
  }

  return <>{children}</>;
}
